/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Subscription_Exclusive_Feature_Sunshine_SubtitleInputs */

const en_subscription_exclusive_feature_sunshine_subtitle = /** @type {(inputs: Subscription_Exclusive_Feature_Sunshine_SubtitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Unlimited Sunshine Elixir`)
};

const ar_subscription_exclusive_feature_sunshine_subtitle = /** @type {(inputs: Subscription_Exclusive_Feature_Sunshine_SubtitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`إكسير صن شاين غير محدود`)
};

const de_subscription_exclusive_feature_sunshine_subtitle = /** @type {(inputs: Subscription_Exclusive_Feature_Sunshine_SubtitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Unbegrenztes Sonnenschein-Elixier`)
};

const es_subscription_exclusive_feature_sunshine_subtitle = /** @type {(inputs: Subscription_Exclusive_Feature_Sunshine_SubtitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Elixir de Sol ilimitado`)
};

const fr_subscription_exclusive_feature_sunshine_subtitle = /** @type {(inputs: Subscription_Exclusive_Feature_Sunshine_SubtitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Élixir de soleil illimité`)
};

const it_subscription_exclusive_feature_sunshine_subtitle = /** @type {(inputs: Subscription_Exclusive_Feature_Sunshine_SubtitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Elisir del Sole illimitato`)
};

const ja_subscription_exclusive_feature_sunshine_subtitle = /** @type {(inputs: Subscription_Exclusive_Feature_Sunshine_SubtitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`無制限のサンシャインエリクサー`)
};

const ko_subscription_exclusive_feature_sunshine_subtitle = /** @type {(inputs: Subscription_Exclusive_Feature_Sunshine_SubtitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`무제한 선샤인 엘릭서`)
};

const pt_br_subscription_exclusive_feature_sunshine_subtitle = /** @type {(inputs: Subscription_Exclusive_Feature_Sunshine_SubtitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Elixir Solar ilimitado`)
};

const ru_subscription_exclusive_feature_sunshine_subtitle = /** @type {(inputs: Subscription_Exclusive_Feature_Sunshine_SubtitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Безлимитный солнечный эликсир`)
};

const th_subscription_exclusive_feature_sunshine_subtitle = /** @type {(inputs: Subscription_Exclusive_Feature_Sunshine_SubtitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`น้ำอมฤตแสงตะวันแบบไม่จำกัด`)
};

const tr_subscription_exclusive_feature_sunshine_subtitle = /** @type {(inputs: Subscription_Exclusive_Feature_Sunshine_SubtitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Sınırsız Günışığı İksiri`)
};

const zh_cn_subscription_exclusive_feature_sunshine_subtitle = /** @type {(inputs: Subscription_Exclusive_Feature_Sunshine_SubtitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`阳光精华无限用`)
};

const zh_tw_subscription_exclusive_feature_sunshine_subtitle = /** @type {(inputs: Subscription_Exclusive_Feature_Sunshine_SubtitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`陽光菁華無限用`)
};

/**
* | output |
* | --- |
* | "Unlimited Sunshine Elixir" |
*
* @param {Subscription_Exclusive_Feature_Sunshine_SubtitleInputs} inputs
* @param {{ locale?: "en" | "ar" | "de" | "es" | "fr" | "it" | "ja" | "ko" | "pt_br" | "ru" | "th" | "tr" | "zh_cn" | "zh_tw" }} options
* @returns {LocalizedString}
*/
export const subscription_exclusive_feature_sunshine_subtitle = /** @type {((inputs?: Subscription_Exclusive_Feature_Sunshine_SubtitleInputs, options?: { locale?: "en" | "ar" | "de" | "es" | "fr" | "it" | "ja" | "ko" | "pt_br" | "ru" | "th" | "tr" | "zh_cn" | "zh_tw" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Subscription_Exclusive_Feature_Sunshine_SubtitleInputs, { locale?: "en" | "ar" | "de" | "es" | "fr" | "it" | "ja" | "ko" | "pt_br" | "ru" | "th" | "tr" | "zh_cn" | "zh_tw" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_subscription_exclusive_feature_sunshine_subtitle(inputs)
	if (locale === "ar") return ar_subscription_exclusive_feature_sunshine_subtitle(inputs)
	if (locale === "de") return de_subscription_exclusive_feature_sunshine_subtitle(inputs)
	if (locale === "es") return es_subscription_exclusive_feature_sunshine_subtitle(inputs)
	if (locale === "fr") return fr_subscription_exclusive_feature_sunshine_subtitle(inputs)
	if (locale === "it") return it_subscription_exclusive_feature_sunshine_subtitle(inputs)
	if (locale === "ja") return ja_subscription_exclusive_feature_sunshine_subtitle(inputs)
	if (locale === "ko") return ko_subscription_exclusive_feature_sunshine_subtitle(inputs)
	if (locale === "pt_br") return pt_br_subscription_exclusive_feature_sunshine_subtitle(inputs)
	if (locale === "ru") return ru_subscription_exclusive_feature_sunshine_subtitle(inputs)
	if (locale === "th") return th_subscription_exclusive_feature_sunshine_subtitle(inputs)
	if (locale === "tr") return tr_subscription_exclusive_feature_sunshine_subtitle(inputs)
	if (locale === "zh_cn") return zh_cn_subscription_exclusive_feature_sunshine_subtitle(inputs)
	return zh_tw_subscription_exclusive_feature_sunshine_subtitle(inputs)
});